import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
@Component({
  selector: 'app-user-master-grid',
  templateUrl: './user-master-grid.component.html',
  styleUrls: ['./user-master-grid.component.scss']
})
export class UserMasterGridComponent implements OnInit {

  constructor(public appservice:AppService ,public location:Location,public router:Router,public cdr:ChangeDetectorRef) { }
 employees = [
    { id: 1, name: 'Alice', department: 'HR', salary: 50000 },
    { id: 2, name: 'Bob', department: 'Engineering', salary: 75000 },
    { id: 3, name: 'Charlie', department: 'Marketing', salary: 60000 }
  ];
   public employeemasterdata1:any={}
   public usermasterdatas:any[]=[]
   public usermastereditid: any = '';
  getusermaster(){
    this.appservice.getTable("api/Transaction/Get_User_Details").subscribe((res:any)=>{
      this.usermasterdatas=JSON.parse(res);
      //console.log("the values",this.employeemasterdata);
        });
  }
  editUser(id:any){
     console.log("EDIT ID:", id);

  this.appservice.usermastereditid = id;

  this.router.navigate(['/home/User_Master']);
  }
  deleteUser(id:any){
    if(confirm("Are you sure to delete the record?")){
      this.appservice.getTable("api/Master/Delete_UserMaster?userid="+id).subscribe((res:any)=>{
        if(res!=''){
          this.refresh();
          this.getusermaster();
        }
      });
    }}
  gotousermaster(){
    this.appservice.usermastereditid='';
    return this.router.navigate(['/home/User_Master'])
  }
  refresh(){
     this.appservice.getTable("api/Transaction/Get_User_Details").subscribe((res:any)=>{
    if (typeof res === 'string') {
  try {

    const clean = res.replace(/[\u0000-\u001F\u007F]/g, '');
    this.usermasterdatas = JSON.parse(clean);
  } catch (e) {
    console.error("Cleaned JSON parse error:", e);
    this.usermasterdatas= [];
  }
} else {
  this.usermasterdatas = res;
}
});
  }
  ngOnInit(): void {
  
     this.appservice.getTable("api/Transaction/Get_User_Details").subscribe((res:any)=>{
    if (typeof res === 'string') {
  try {
   
    const clean = res.replace(/[\u0000-\u001F\u007F]/g, '');
    this.usermasterdatas = JSON.parse(clean);
  } catch (e) {
    console.error("Cleaned JSON parse error:", e);
    this.usermasterdatas = [];
  }
} else {
  this.usermasterdatas = res;
}
});
  }

}